import axios from "axios";

const api = axios.create({
  // baseURL: "http://localhost:5000/api/v1/", // change this to your backend URL
  // baseURL: "https://tarsara.chintansumulparlour.in/api/v1/", // change this to your backend URL
  baseURL: "https://backend.tarsariyaparivar.in/api/v1/", // change this to your backend URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically add token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `${token}`;
  }
  return config;
});

export default api;
